<script lang="ts">
import { ChangePassword } from "@/dashboard/my-account/change-password/change-password.ts";
export default ChangePassword;
</script>

<template>
    <div class="account__tab tab--3 is-open">
        <form class="account__form" @submit="form.onSubmit">
            <div class="row">
                <div class="col-12 col-xl-6">
                    <div class="row form__field">
                        <div
                            class="col form__col"
                            :class="{
                                'form__group--active':
                                    oldPasswordFocused || form.values.old_password,
                            }"
                        >
                            <input
                                class="form__input"
                                :type="inputType"
                                tabindex="1"
                                autocomplete="off"
                                :readonly="!oldPasswordFocused"
                                @focus="oldPasswordFocused = true"
                                @blur="oldPasswordFocused = false"
                                v-model="form.values.old_password"
                                :class="{ '--error': form.errors.old_password }"
                            />

                            <label class="form__label required">
                                <i18n-t
                                    keypath="dashboard.myAccountComponent.loginInfoTab.oldPassword"
                                />
                            </label>
                        </div>
                    </div>

                    <div class="row form__field">
                        <div
                            class="col-sm-6 form__col"
                            :class="{
                                'form__group--active':
                                    newPasswordFocused || form.values.new_password,
                            }"
                        >
                            <input
                                class="form__input"
                                :type="inputType"
                                tabindex="2"
                                autocomplete="off"
                                :readonly="!newPasswordFocused"
                                @focus="newPasswordFocused = true"
                                @blur="newPasswordFocused = false"
                                v-model="form.values.new_password"
                                :class="{ '--error': form.errors.new_password }"
                            />

                            <label class="form__label required">
                                <i18n-t
                                    keypath="dashboard.myAccountComponent.loginInfoTab.newPassword"
                                />
                            </label>
                            <button
                                @click="showPassword()"
                                class="form__pass"
                                type="button"
                            >
                                <span
                                    :class="{
                                        'bg-eye': inputType === 'password',
                                        'bg-eye__on': inputType === 'text',
                                    }"
                                ></span>
                            </button>
                        </div>
                        <div
                            class="col-sm-6 form__col"
                            :class="{
                                'form__group--active':
                                    repeatedPasswordFocused ||
                                    form.values.new_password_repeated,
                            }"
                        >
                            <input
                                class="form__input"
                                :type="inputType"
                                tabindex="3"
                                @focus="repeatedPasswordFocused = true"
                                @blur="repeatedPasswordFocused = false"
                                autocomplete="off"
                                :readonly="!repeatedPasswordFocused"
                                v-model="form.values.new_password_repeated"
                                :class="{ '--error': form.errors.new_password_repeated }"
                            />

                            <label class="form__label required">
                                <i18n-t
                                    keypath="dashboard.myAccountComponent.loginInfoTab.repeatPassword"
                                />
                            </label>
                            <button
                                @click="showPassword()"
                                class="form__pass"
                                type="button"
                            >
                                <span
                                    :class="{
                                        'bg-eye': inputType === 'password',
                                        'bg-eye__on': inputType === 'text',
                                    }"
                                ></span>
                            </button>
                        </div>
                    </div>

                    <div class="row form__field">
                        <div class="col form__col btn__col">
                            <button class="button" type="submit" tabindex="4">
                                <i18n-t keypath="dashboard.myAccountComponent.saveBtn" />
                                <span
                                    v-if="isLoading"
                                    style="
                                        margin-left: 10px;
                                        margin-top: 1px;
                                        position: absolute;
                                    "
                                    class="p-button-loading-icon pi pi-spinner pi-spin"
                                ></span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>
